// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/library_release.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
/**
 * @generated from message mono.projectdata.v1.LibraryAudienceGrant
 */ export class LibraryAudienceGrant extends Message {
    static fromBinary(bytes, options) {
        return new LibraryAudienceGrant().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LibraryAudienceGrant().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LibraryAudienceGrant().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LibraryAudienceGrant, a, b);
    }
    constructor(data){
        super(), /**
   * scope_node | principal_group
   *
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string scope_node_id = 2;
   */ _define_property(this, "scopeNodeId", ""), /**
   * @generated from field: string principal_group_id = 3;
   */ _define_property(this, "principalGroupId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LibraryAudienceGrant, "runtime", proto3);
_define_property(LibraryAudienceGrant, "typeName", "mono.projectdata.v1.LibraryAudienceGrant");
_define_property(LibraryAudienceGrant, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "scope_node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "principal_group_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ReleaseLibraryItemRequest
 */ export class ReleaseLibraryItemRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReleaseLibraryItemRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReleaseLibraryItemRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReleaseLibraryItemRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReleaseLibraryItemRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Deliberate release decision; empty defaults conservatively to internal_only.
   *
   * internal_only | external_eligible
   *
   * @generated from field: string external_output_eligibility = 10;
   */ _define_property(this, "externalOutputEligibility", ""), /**
   * required for external_eligible
   *
   * @generated from field: string external_output_restrictions = 11;
   */ _define_property(this, "externalOutputRestrictions", ""), /**
   * @generated from field: string working_version_id = 9;
   */ _define_property(this, "workingVersionId", ""), /**
   * @generated from field: string library_item_id = 1;
   */ _define_property(this, "libraryItemId", ""), /**
   * @generated from field: string released_title = 2;
   */ _define_property(this, "releasedTitle", ""), /**
   * @generated from field: string released_content = 3;
   */ _define_property(this, "releasedContent", ""), /**
   * plain_text | markdown | html
   *
   * @generated from field: string released_content_format = 4;
   */ _define_property(this, "releasedContentFormat", ""), /**
   * @generated from field: string restrictions = 5;
   */ _define_property(this, "restrictions", ""), /**
   * @generated from field: repeated mono.projectdata.v1.LibraryAudienceGrant audiences = 6;
   */ _define_property(this, "audiences", []), /**
   * @generated from field: string user_id = 7;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 8;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReleaseLibraryItemRequest, "runtime", proto3);
_define_property(ReleaseLibraryItemRequest, "typeName", "mono.projectdata.v1.ReleaseLibraryItemRequest");
_define_property(ReleaseLibraryItemRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 10,
            name: "external_output_eligibility",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "external_output_restrictions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "working_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 1,
            name: "library_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "released_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "released_content",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "released_content_format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "restrictions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "audiences",
            kind: "message",
            T: LibraryAudienceGrant,
            repeated: true
        },
        {
            no: 7,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ReleaseLibraryItemResponse
 */ export class ReleaseLibraryItemResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReleaseLibraryItemResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReleaseLibraryItemResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReleaseLibraryItemResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReleaseLibraryItemResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string release_id = 1;
   */ _define_property(this, "releaseId", ""), /**
   * @generated from field: int32 version = 2;
   */ _define_property(this, "version", 0), /**
   * @generated from field: google.protobuf.Timestamp released_at = 3;
   */ _define_property(this, "releasedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReleaseLibraryItemResponse, "runtime", proto3);
_define_property(ReleaseLibraryItemResponse, "typeName", "mono.projectdata.v1.ReleaseLibraryItemResponse");
_define_property(ReleaseLibraryItemResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "release_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "released_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.WithdrawLibraryReleaseRequest
 */ export class WithdrawLibraryReleaseRequest extends Message {
    static fromBinary(bytes, options) {
        return new WithdrawLibraryReleaseRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WithdrawLibraryReleaseRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WithdrawLibraryReleaseRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WithdrawLibraryReleaseRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string release_id = 1;
   */ _define_property(this, "releaseId", ""), /**
   * @generated from field: string reason = 2;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 4;
   */ _define_property(this, "companyId", ""), /**
   * The released item; zou authorizes withdraw against its source scope.
   *
   * @generated from field: string library_item_id = 5;
   */ _define_property(this, "libraryItemId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(WithdrawLibraryReleaseRequest, "runtime", proto3);
_define_property(WithdrawLibraryReleaseRequest, "typeName", "mono.projectdata.v1.WithdrawLibraryReleaseRequest");
_define_property(WithdrawLibraryReleaseRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "release_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "library_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.WithdrawLibraryReleaseResponse
 */ export class WithdrawLibraryReleaseResponse extends Message {
    static fromBinary(bytes, options) {
        return new WithdrawLibraryReleaseResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WithdrawLibraryReleaseResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WithdrawLibraryReleaseResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WithdrawLibraryReleaseResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(WithdrawLibraryReleaseResponse, "runtime", proto3);
_define_property(WithdrawLibraryReleaseResponse, "typeName", "mono.projectdata.v1.WithdrawLibraryReleaseResponse");
_define_property(WithdrawLibraryReleaseResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.projectdata.v1.GetReleasedDerivativeRequest
 */ export class GetReleasedDerivativeRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetReleasedDerivativeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetReleasedDerivativeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetReleasedDerivativeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetReleasedDerivativeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string library_item_id = 1;
   */ _define_property(this, "libraryItemId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetReleasedDerivativeRequest, "runtime", proto3);
_define_property(GetReleasedDerivativeRequest, "typeName", "mono.projectdata.v1.GetReleasedDerivativeRequest");
_define_property(GetReleasedDerivativeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "library_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetReleasedDerivativeResponse
 */ export class GetReleasedDerivativeResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetReleasedDerivativeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetReleasedDerivativeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetReleasedDerivativeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetReleasedDerivativeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.LibraryReleaseContext release_context = 10;
   */ _define_property(this, "releaseContext", void 0), /**
   * @generated from field: string library_item_id = 1;
   */ _define_property(this, "libraryItemId", ""), /**
   * @generated from field: string release_id = 2;
   */ _define_property(this, "releaseId", ""), /**
   * @generated from field: int32 version = 3;
   */ _define_property(this, "version", 0), /**
   * @generated from field: string released_title = 4;
   */ _define_property(this, "releasedTitle", ""), /**
   * @generated from field: string released_content = 5;
   */ _define_property(this, "releasedContent", ""), /**
   * @generated from field: string released_content_format = 6;
   */ _define_property(this, "releasedContentFormat", ""), /**
   * @generated from field: google.protobuf.Timestamp released_at = 7;
   */ _define_property(this, "releasedAt", void 0), /**
   * @generated from field: string restrictions = 8;
   */ _define_property(this, "restrictions", ""), /**
   * @generated from field: bool withdrawn = 9;
   */ _define_property(this, "withdrawn", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetReleasedDerivativeResponse, "runtime", proto3);
_define_property(GetReleasedDerivativeResponse, "typeName", "mono.projectdata.v1.GetReleasedDerivativeResponse");
_define_property(GetReleasedDerivativeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 10,
            name: "release_context",
            kind: "message",
            T: LibraryReleaseContext
        },
        {
            no: 1,
            name: "library_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "release_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "released_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "released_content",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "released_content_format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "released_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "restrictions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "withdrawn",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListSelectableReleasesRequest
 */ export class ListSelectableReleasesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListSelectableReleasesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSelectableReleasesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSelectableReleasesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSelectableReleasesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * optional filter
   *
   * @generated from field: string item_type = 1;
   */ _define_property(this, "itemType", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSelectableReleasesRequest, "runtime", proto3);
_define_property(ListSelectableReleasesRequest, "typeName", "mono.projectdata.v1.ListSelectableReleasesRequest");
_define_property(ListSelectableReleasesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SelectableRelease
 */ export class SelectableRelease extends Message {
    static fromBinary(bytes, options) {
        return new SelectableRelease().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SelectableRelease().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SelectableRelease().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SelectableRelease, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.LibraryReleaseContext release_context = 6;
   */ _define_property(this, "releaseContext", void 0), /**
   * @generated from field: string library_item_id = 1;
   */ _define_property(this, "libraryItemId", ""), /**
   * @generated from field: string release_id = 2;
   */ _define_property(this, "releaseId", ""), /**
   * @generated from field: int32 version = 3;
   */ _define_property(this, "version", 0), /**
   * @generated from field: string released_title = 4;
   */ _define_property(this, "releasedTitle", ""), /**
   * @generated from field: google.protobuf.Timestamp released_at = 5;
   */ _define_property(this, "releasedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SelectableRelease, "runtime", proto3);
_define_property(SelectableRelease, "typeName", "mono.projectdata.v1.SelectableRelease");
_define_property(SelectableRelease, "fields", proto3.util.newFieldList(()=>[
        {
            no: 6,
            name: "release_context",
            kind: "message",
            T: LibraryReleaseContext
        },
        {
            no: 1,
            name: "library_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "release_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "released_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "released_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListSelectableReleasesResponse
 */ export class ListSelectableReleasesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListSelectableReleasesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSelectableReleasesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSelectableReleasesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSelectableReleasesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.SelectableRelease releases = 1;
   */ _define_property(this, "releases", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSelectableReleasesResponse, "runtime", proto3);
_define_property(ListSelectableReleasesResponse, "typeName", "mono.projectdata.v1.ListSelectableReleasesResponse");
_define_property(ListSelectableReleasesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "releases",
            kind: "message",
            T: SelectableRelease,
            repeated: true
        }
    ]));
/**
 * LibraryReuseView is a reuse as its caller may see it now. Content is withheld
 * only when access is denied; withdrawal preserves permitted history. It
 * never carries prepared_content, the owning scope or provenance records.
 *
 * @generated from message mono.projectdata.v1.LibraryReuseView
 */ export class LibraryReuseView extends Message {
    static fromBinary(bytes, options) {
        return new LibraryReuseView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LibraryReuseView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LibraryReuseView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LibraryReuseView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.LibraryReleaseContext release_context = 18;
   */ _define_property(this, "releaseContext", void 0), /**
   * @generated from field: string reuse_id = 1;
   */ _define_property(this, "reuseId", ""), /**
   * @generated from field: string library_item_id = 2;
   */ _define_property(this, "libraryItemId", ""), /**
   * live_reference | adopted | frozen_snapshot
   *
   * @generated from field: string transfer_mode = 3;
   */ _define_property(this, "transferMode", ""), /**
   * @generated from field: string receiving_object_type = 4;
   */ _define_property(this, "receivingObjectType", ""), /**
   * @generated from field: string receiving_object_id = 5;
   */ _define_property(this, "receivingObjectId", ""), /**
   * @generated from field: string release_id = 6;
   */ _define_property(this, "releaseId", ""), /**
   * version recorded when the reuse was made
   *
   * @generated from field: int32 source_version = 7;
   */ _define_property(this, "sourceVersion", 0), /**
   * version whose content is shown (0 = adopted)
   *
   * @generated from field: int32 resolved_version = 8;
   */ _define_property(this, "resolvedVersion", 0), /**
   * resolved | source_withdrawn
   *
   * @generated from field: string status = 9;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string title = 10;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string content = 11;
   */ _define_property(this, "content", ""), /**
   * @generated from field: string content_format = 12;
   */ _define_property(this, "contentFormat", ""), /**
   * @generated from field: google.protobuf.Timestamp source_withdrawn_at = 13;
   */ _define_property(this, "sourceWithdrawnAt", void 0), /**
   * @generated from field: bool editable = 14;
   */ _define_property(this, "editable", false), /**
   * @generated from field: int32 revision = 15;
   */ _define_property(this, "revision", 0), /**
   * @generated from field: string reused_by_user_id = 16;
   */ _define_property(this, "reusedByUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 17;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LibraryReuseView, "runtime", proto3);
_define_property(LibraryReuseView, "typeName", "mono.projectdata.v1.LibraryReuseView");
_define_property(LibraryReuseView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 18,
            name: "release_context",
            kind: "message",
            T: LibraryReleaseContext
        },
        {
            no: 1,
            name: "reuse_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "library_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "transfer_mode",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "receiving_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "receiving_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "release_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "source_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "resolved_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "content",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "content_format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "source_withdrawn_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "editable",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 15,
            name: "revision",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 16,
            name: "reused_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateLibraryReuseRequest
 */ export class CreateLibraryReuseRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateLibraryReuseRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateLibraryReuseRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateLibraryReuseRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateLibraryReuseRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string release_id = 1;
   */ _define_property(this, "releaseId", ""), /**
   * @generated from field: string transfer_mode = 2;
   */ _define_property(this, "transferMode", ""), /**
   * @generated from field: string receiving_object_type = 3;
   */ _define_property(this, "receivingObjectType", ""), /**
   * @generated from field: string receiving_object_id = 4;
   */ _define_property(this, "receivingObjectId", ""), /**
   * @generated from field: string user_id = 5;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 6;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateLibraryReuseRequest, "runtime", proto3);
_define_property(CreateLibraryReuseRequest, "typeName", "mono.projectdata.v1.CreateLibraryReuseRequest");
_define_property(CreateLibraryReuseRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "release_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "transfer_mode",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "receiving_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "receiving_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateLibraryReuseResponse
 */ export class CreateLibraryReuseResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateLibraryReuseResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateLibraryReuseResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateLibraryReuseResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateLibraryReuseResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.LibraryReuseView reuse = 1;
   */ _define_property(this, "reuse", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateLibraryReuseResponse, "runtime", proto3);
_define_property(CreateLibraryReuseResponse, "typeName", "mono.projectdata.v1.CreateLibraryReuseResponse");
_define_property(CreateLibraryReuseResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "reuse",
            kind: "message",
            T: LibraryReuseView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ResolveLibraryReuseRequest
 */ export class ResolveLibraryReuseRequest extends Message {
    static fromBinary(bytes, options) {
        return new ResolveLibraryReuseRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveLibraryReuseRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveLibraryReuseRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveLibraryReuseRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string reuse_id = 1;
   */ _define_property(this, "reuseId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveLibraryReuseRequest, "runtime", proto3);
_define_property(ResolveLibraryReuseRequest, "typeName", "mono.projectdata.v1.ResolveLibraryReuseRequest");
_define_property(ResolveLibraryReuseRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "reuse_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ResolveLibraryReuseResponse
 */ export class ResolveLibraryReuseResponse extends Message {
    static fromBinary(bytes, options) {
        return new ResolveLibraryReuseResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveLibraryReuseResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveLibraryReuseResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveLibraryReuseResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.LibraryReuseView reuse = 1;
   */ _define_property(this, "reuse", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveLibraryReuseResponse, "runtime", proto3);
_define_property(ResolveLibraryReuseResponse, "typeName", "mono.projectdata.v1.ResolveLibraryReuseResponse");
_define_property(ResolveLibraryReuseResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "reuse",
            kind: "message",
            T: LibraryReuseView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.EditAdoptedLibraryReuseRequest
 */ export class EditAdoptedLibraryReuseRequest extends Message {
    static fromBinary(bytes, options) {
        return new EditAdoptedLibraryReuseRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EditAdoptedLibraryReuseRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EditAdoptedLibraryReuseRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EditAdoptedLibraryReuseRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string reuse_id = 1;
   */ _define_property(this, "reuseId", ""), /**
   * @generated from field: string content = 2;
   */ _define_property(this, "content", ""), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 4;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EditAdoptedLibraryReuseRequest, "runtime", proto3);
_define_property(EditAdoptedLibraryReuseRequest, "typeName", "mono.projectdata.v1.EditAdoptedLibraryReuseRequest");
_define_property(EditAdoptedLibraryReuseRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "reuse_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "content",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.EditAdoptedLibraryReuseResponse
 */ export class EditAdoptedLibraryReuseResponse extends Message {
    static fromBinary(bytes, options) {
        return new EditAdoptedLibraryReuseResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EditAdoptedLibraryReuseResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EditAdoptedLibraryReuseResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EditAdoptedLibraryReuseResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.LibraryReuseView reuse = 1;
   */ _define_property(this, "reuse", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(EditAdoptedLibraryReuseResponse, "runtime", proto3);
_define_property(EditAdoptedLibraryReuseResponse, "typeName", "mono.projectdata.v1.EditAdoptedLibraryReuseResponse");
_define_property(EditAdoptedLibraryReuseResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "reuse",
            kind: "message",
            T: LibraryReuseView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListLibraryReusesRequest
 */ export class ListLibraryReusesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListLibraryReusesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLibraryReusesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLibraryReusesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLibraryReusesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * optional related uses; receiver access is rechecked
   *
   * @generated from field: string library_item_id = 5;
   */ _define_property(this, "libraryItemId", ""), /**
   * @generated from field: string receiving_object_type = 1;
   */ _define_property(this, "receivingObjectType", ""), /**
   * @generated from field: string receiving_object_id = 2;
   */ _define_property(this, "receivingObjectId", ""), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 4;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLibraryReusesRequest, "runtime", proto3);
_define_property(ListLibraryReusesRequest, "typeName", "mono.projectdata.v1.ListLibraryReusesRequest");
_define_property(ListLibraryReusesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 5,
            name: "library_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 1,
            name: "receiving_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "receiving_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListLibraryReusesResponse
 */ export class ListLibraryReusesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListLibraryReusesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLibraryReusesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLibraryReusesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLibraryReusesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.LibraryReuseView reuses = 1;
   */ _define_property(this, "reuses", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLibraryReusesResponse, "runtime", proto3);
_define_property(ListLibraryReusesResponse, "typeName", "mono.projectdata.v1.ListLibraryReusesResponse");
_define_property(ListLibraryReusesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "reuses",
            kind: "message",
            T: LibraryReuseView,
            repeated: true
        }
    ]));
/**
 * Corrections create working versions only. Release is a separate authorized act.
 *
 * @generated from message mono.projectdata.v1.CorrectLibrarySourceRequest
 */ export class CorrectLibrarySourceRequest extends Message {
    static fromBinary(bytes, options) {
        return new CorrectLibrarySourceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CorrectLibrarySourceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CorrectLibrarySourceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CorrectLibrarySourceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string library_item_id = 3;
   */ _define_property(this, "libraryItemId", ""), /**
   * @generated from field: string title = 4;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string content = 5;
   */ _define_property(this, "content", ""), /**
   * @generated from field: string correction_reason = 6;
   */ _define_property(this, "correctionReason", ""), /**
   * @generated from field: string expected_working_version_id = 7;
   */ _define_property(this, "expectedWorkingVersionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CorrectLibrarySourceRequest, "runtime", proto3);
_define_property(CorrectLibrarySourceRequest, "typeName", "mono.projectdata.v1.CorrectLibrarySourceRequest");
_define_property(CorrectLibrarySourceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "library_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "content",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "correction_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "expected_working_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CorrectLibrarySourceResponse
 */ export class CorrectLibrarySourceResponse extends Message {
    static fromBinary(bytes, options) {
        return new CorrectLibrarySourceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CorrectLibrarySourceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CorrectLibrarySourceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CorrectLibrarySourceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string working_version_id = 1;
   */ _define_property(this, "workingVersionId", ""), /**
   * @generated from field: int32 version = 2;
   */ _define_property(this, "version", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CorrectLibrarySourceResponse, "runtime", proto3);
_define_property(CorrectLibrarySourceResponse, "typeName", "mono.projectdata.v1.CorrectLibrarySourceResponse");
_define_property(CorrectLibrarySourceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "working_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CompareLibrarySourceChangeRequest
 */ export class CompareLibrarySourceChangeRequest extends Message {
    static fromBinary(bytes, options) {
        return new CompareLibrarySourceChangeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompareLibrarySourceChangeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompareLibrarySourceChangeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompareLibrarySourceChangeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string reuse_id = 3;
   */ _define_property(this, "reuseId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompareLibrarySourceChangeRequest, "runtime", proto3);
_define_property(CompareLibrarySourceChangeRequest, "typeName", "mono.projectdata.v1.CompareLibrarySourceChangeRequest");
_define_property(CompareLibrarySourceChangeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "reuse_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.LibrarySourceChange
 */ export class LibrarySourceChange extends Message {
    static fromBinary(bytes, options) {
        return new LibrarySourceChange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LibrarySourceChange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LibrarySourceChange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LibrarySourceChange, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string reuse_id = 1;
   */ _define_property(this, "reuseId", ""), /**
   * @generated from field: string release_id = 2;
   */ _define_property(this, "releaseId", ""), /**
   * @generated from field: string old_content = 3;
   */ _define_property(this, "oldContent", ""), /**
   * @generated from field: string new_content = 4;
   */ _define_property(this, "newContent", ""), /**
   * @generated from field: string correction_reason = 5;
   */ _define_property(this, "correctionReason", ""), /**
   * @generated from field: int32 source_version = 6;
   */ _define_property(this, "sourceVersion", 0), /**
   * @generated from field: int32 new_version = 7;
   */ _define_property(this, "newVersion", 0), /**
   * @generated from field: int32 adopted_revision = 8;
   */ _define_property(this, "adoptedRevision", 0), /**
   * @generated from field: string decision = 9;
   */ _define_property(this, "decision", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LibrarySourceChange, "runtime", proto3);
_define_property(LibrarySourceChange, "typeName", "mono.projectdata.v1.LibrarySourceChange");
_define_property(LibrarySourceChange, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "reuse_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "release_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "old_content",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "new_content",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "correction_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "new_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "adopted_revision",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CompareLibrarySourceChangeResponse
 */ export class CompareLibrarySourceChangeResponse extends Message {
    static fromBinary(bytes, options) {
        return new CompareLibrarySourceChangeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompareLibrarySourceChangeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompareLibrarySourceChangeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompareLibrarySourceChangeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.LibrarySourceChange change = 1;
   */ _define_property(this, "change", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompareLibrarySourceChangeResponse, "runtime", proto3);
_define_property(CompareLibrarySourceChangeResponse, "typeName", "mono.projectdata.v1.CompareLibrarySourceChangeResponse");
_define_property(CompareLibrarySourceChangeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change",
            kind: "message",
            T: LibrarySourceChange
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ReviewLibrarySourceChangeRequest
 */ export class ReviewLibrarySourceChangeRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReviewLibrarySourceChangeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewLibrarySourceChangeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewLibrarySourceChangeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewLibrarySourceChangeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string reuse_id = 3;
   */ _define_property(this, "reuseId", ""), /**
   * @generated from field: string release_id = 4;
   */ _define_property(this, "releaseId", ""), /**
   * accept | keep_mine
   *
   * @generated from field: string decision = 5;
   */ _define_property(this, "decision", ""), /**
   * @generated from field: int32 expected_revision = 6;
   */ _define_property(this, "expectedRevision", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewLibrarySourceChangeRequest, "runtime", proto3);
_define_property(ReviewLibrarySourceChangeRequest, "typeName", "mono.projectdata.v1.ReviewLibrarySourceChangeRequest");
_define_property(ReviewLibrarySourceChangeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "reuse_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "release_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "expected_revision",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ReviewLibrarySourceChangeResponse
 */ export class ReviewLibrarySourceChangeResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReviewLibrarySourceChangeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewLibrarySourceChangeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewLibrarySourceChangeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewLibrarySourceChangeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.LibraryReuseView reuse = 1;
   */ _define_property(this, "reuse", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewLibrarySourceChangeResponse, "runtime", proto3);
_define_property(ReviewLibrarySourceChangeResponse, "typeName", "mono.projectdata.v1.ReviewLibrarySourceChangeResponse");
_define_property(ReviewLibrarySourceChangeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "reuse",
            kind: "message",
            T: LibraryReuseView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetLibraryWorkingSourceRequest
 */ export class GetLibraryWorkingSourceRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetLibraryWorkingSourceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLibraryWorkingSourceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLibraryWorkingSourceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLibraryWorkingSourceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string library_item_id = 3;
   */ _define_property(this, "libraryItemId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLibraryWorkingSourceRequest, "runtime", proto3);
_define_property(GetLibraryWorkingSourceRequest, "typeName", "mono.projectdata.v1.GetLibraryWorkingSourceRequest");
_define_property(GetLibraryWorkingSourceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "library_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetLibraryWorkingSourceResponse
 */ export class GetLibraryWorkingSourceResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetLibraryWorkingSourceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLibraryWorkingSourceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLibraryWorkingSourceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLibraryWorkingSourceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string working_version_id = 1;
   */ _define_property(this, "workingVersionId", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string content = 3;
   */ _define_property(this, "content", ""), /**
   * @generated from field: string correction_reason = 4;
   */ _define_property(this, "correctionReason", ""), /**
   * @generated from field: string current_release_id = 5;
   */ _define_property(this, "currentReleaseId", ""), /**
   * @generated from field: int32 current_release_version = 6;
   */ _define_property(this, "currentReleaseVersion", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLibraryWorkingSourceResponse, "runtime", proto3);
_define_property(GetLibraryWorkingSourceResponse, "typeName", "mono.projectdata.v1.GetLibraryWorkingSourceResponse");
_define_property(GetLibraryWorkingSourceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "working_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "content",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "correction_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "current_release_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "current_release_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * Bounded publication metadata. Does not confer audience membership or certify
 * legal suitability. Templates are reusable structure, never accomplishments.
 *
 * @generated from message mono.projectdata.v1.LibraryReleaseContext
 */ export class LibraryReleaseContext extends Message {
    static fromBinary(bytes, options) {
        return new LibraryReleaseContext().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LibraryReleaseContext().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LibraryReleaseContext().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LibraryReleaseContext, a, b);
    }
    constructor(data){
        super(), /**
   * Publication this decision describes; adopted/local wording is not approved.
   *
   * @generated from field: string release_id = 13;
   */ _define_property(this, "releaseId", ""), /**
   * @generated from field: string released_by_user_id = 1;
   */ _define_property(this, "releasedByUserId", ""), /**
   * @generated from field: repeated mono.projectdata.v1.LibraryAudienceGrant audiences = 2;
   */ _define_property(this, "audiences", []), /**
   * @generated from field: string restrictions = 3;
   */ _define_property(this, "restrictions", ""), /**
   * internal_only | external_eligible
   *
   * @generated from field: string external_output_eligibility = 4;
   */ _define_property(this, "externalOutputEligibility", ""), /**
   * @generated from field: string external_output_restrictions = 5;
   */ _define_property(this, "externalOutputRestrictions", ""), /**
   * @generated from field: string working_version_id = 6;
   */ _define_property(this, "workingVersionId", ""), /**
   * released working version only, never latest draft
   *
   * @generated from field: string correction_reason = 7;
   */ _define_property(this, "correctionReason", ""), /**
   * @generated from field: string superseded_by_release_id = 8;
   */ _define_property(this, "supersededByReleaseId", ""), /**
   * @generated from field: google.protobuf.Timestamp withdrawn_at = 9;
   */ _define_property(this, "withdrawnAt", void 0), /**
   * @generated from field: string withdrawn_by_user_id = 10;
   */ _define_property(this, "withdrawnByUserId", ""), /**
   * @generated from field: string withdrawal_reason = 11;
   */ _define_property(this, "withdrawalReason", ""), /**
   * template denotes structure, not proof of accomplishment
   *
   * @generated from field: string item_type = 12;
   */ _define_property(this, "itemType", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LibraryReleaseContext, "runtime", proto3);
_define_property(LibraryReleaseContext, "typeName", "mono.projectdata.v1.LibraryReleaseContext");
_define_property(LibraryReleaseContext, "fields", proto3.util.newFieldList(()=>[
        {
            no: 13,
            name: "release_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 1,
            name: "released_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "audiences",
            kind: "message",
            T: LibraryAudienceGrant,
            repeated: true
        },
        {
            no: 3,
            name: "restrictions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "external_output_eligibility",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "external_output_restrictions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "working_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "correction_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "superseded_by_release_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "withdrawn_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "withdrawn_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "withdrawal_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "item_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Only currently authorized versions are returned; absent and denied both give
 * an empty list with no total. Use the last returned version as the next cursor.
 *
 * @generated from message mono.projectdata.v1.ListLibraryReleaseHistoryRequest
 */ export class ListLibraryReleaseHistoryRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListLibraryReleaseHistoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLibraryReleaseHistoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLibraryReleaseHistoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLibraryReleaseHistoryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string library_item_id = 3;
   */ _define_property(this, "libraryItemId", ""), /**
   * exclusive; zero starts newest
   *
   * @generated from field: int32 before_version = 4;
   */ _define_property(this, "beforeVersion", 0), /**
   * default/max 50
   *
   * @generated from field: int32 limit = 5;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLibraryReleaseHistoryRequest, "runtime", proto3);
_define_property(ListLibraryReleaseHistoryRequest, "typeName", "mono.projectdata.v1.ListLibraryReleaseHistoryRequest");
_define_property(ListLibraryReleaseHistoryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "library_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "before_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListLibraryReleaseHistoryResponse
 */ export class ListLibraryReleaseHistoryResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListLibraryReleaseHistoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLibraryReleaseHistoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLibraryReleaseHistoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLibraryReleaseHistoryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.GetReleasedDerivativeResponse releases = 1;
   */ _define_property(this, "releases", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLibraryReleaseHistoryResponse, "runtime", proto3);
_define_property(ListLibraryReleaseHistoryResponse, "typeName", "mono.projectdata.v1.ListLibraryReleaseHistoryResponse");
_define_property(ListLibraryReleaseHistoryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "releases",
            kind: "message",
            T: GetReleasedDerivativeResponse,
            repeated: true
        }
    ]));
/**
 * Only title/summary and the selected audience are published. Source identifiers
 * stay in the authorized working context. Preview is reauthorized at release.
 *
 * @generated from message mono.projectdata.v1.ReleaseCustomerContextRequest
 */ export class ReleaseCustomerContextRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReleaseCustomerContextRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReleaseCustomerContextRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReleaseCustomerContextRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReleaseCustomerContextRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * interaction | theme (accepted only)
   *
   * @generated from field: string source_kind = 4;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string source_id = 5;
   */ _define_property(this, "sourceId", ""), /**
   * @generated from field: string title = 6;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string summary = 7;
   */ _define_property(this, "summary", ""), /**
   * @generated from field: repeated mono.projectdata.v1.LibraryAudienceGrant audiences = 8;
   */ _define_property(this, "audiences", []), /**
   * binds exact content, audience and source revision
   *
   * @generated from field: string preview_token = 9;
   */ _define_property(this, "previewToken", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReleaseCustomerContextRequest, "runtime", proto3);
_define_property(ReleaseCustomerContextRequest, "typeName", "mono.projectdata.v1.ReleaseCustomerContextRequest");
_define_property(ReleaseCustomerContextRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "audiences",
            kind: "message",
            T: LibraryAudienceGrant,
            repeated: true
        },
        {
            no: 9,
            name: "preview_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PreviewCustomerContextResponse
 */ export class PreviewCustomerContextResponse extends Message {
    static fromBinary(bytes, options) {
        return new PreviewCustomerContextResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PreviewCustomerContextResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PreviewCustomerContextResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PreviewCustomerContextResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string title = 1;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string summary = 2;
   */ _define_property(this, "summary", ""), /**
   * @generated from field: repeated mono.projectdata.v1.LibraryAudienceGrant audiences = 3;
   */ _define_property(this, "audiences", []), /**
   * @generated from field: string preview_token = 4;
   */ _define_property(this, "previewToken", ""), /**
   * selected public customer association
   *
   * @generated from field: string customer_org_id = 5;
   */ _define_property(this, "customerOrgId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PreviewCustomerContextResponse, "runtime", proto3);
_define_property(PreviewCustomerContextResponse, "typeName", "mono.projectdata.v1.PreviewCustomerContextResponse");
_define_property(PreviewCustomerContextResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "audiences",
            kind: "message",
            T: LibraryAudienceGrant,
            repeated: true
        },
        {
            no: 4,
            name: "preview_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "customer_org_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * library_item_id + release_id + version are the derivative origin for existing
 * library live/adopted/frozen reuse. No raw source IDs, counts or metadata.
 *
 * @generated from message mono.projectdata.v1.CustomerContextSummary
 */ export class CustomerContextSummary extends Message {
    static fromBinary(bytes, options) {
        return new CustomerContextSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CustomerContextSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CustomerContextSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CustomerContextSummary, a, b);
    }
    constructor(data){
        super(), /**
   * theme | interaction | library_evidence
   *
   * @generated from field: string context_kind = 10;
   */ _define_property(this, "contextKind", ""), /**
   * @generated from field: string library_item_id = 1;
   */ _define_property(this, "libraryItemId", ""), /**
   * @generated from field: string release_id = 2;
   */ _define_property(this, "releaseId", ""), /**
   * @generated from field: int32 version = 3;
   */ _define_property(this, "version", 0), /**
   * @generated from field: string title = 4;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string summary = 5;
   */ _define_property(this, "summary", ""), /**
   * @generated from field: string provenance = 6;
   */ _define_property(this, "provenance", ""), /**
   * @generated from field: google.protobuf.Timestamp reviewed_at = 7;
   */ _define_property(this, "reviewedAt", void 0), /**
   * current | source_changed | source_unavailable | withdrawn | superseded
   *
   * @generated from field: string status = 8;
   */ _define_property(this, "status", ""), /**
   * @generated from field: google.protobuf.Timestamp released_at = 9;
   */ _define_property(this, "releasedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CustomerContextSummary, "runtime", proto3);
_define_property(CustomerContextSummary, "typeName", "mono.projectdata.v1.CustomerContextSummary");
_define_property(CustomerContextSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 10,
            name: "context_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 1,
            name: "library_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "release_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "provenance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "reviewed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "released_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetCustomerContextRequest
 */ export class GetCustomerContextRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCustomerContextRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCustomerContextRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCustomerContextRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCustomerContextRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string library_item_id = 3;
   */ _define_property(this, "libraryItemId", ""), /**
   * optional immutable history version
   *
   * @generated from field: string release_id = 4;
   */ _define_property(this, "releaseId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCustomerContextRequest, "runtime", proto3);
_define_property(GetCustomerContextRequest, "typeName", "mono.projectdata.v1.GetCustomerContextRequest");
_define_property(GetCustomerContextRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "library_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "release_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCustomerContextsRequest
 */ export class ListCustomerContextsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCustomerContextsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCustomerContextsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCustomerContextsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCustomerContextsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * source-authorized Theme detail only
   *
   * @generated from field: string capture_project_id = 4;
   */ _define_property(this, "captureProjectId", ""), /**
   * private source filter; never returned
   *
   * @generated from field: string theme_id = 5;
   */ _define_property(this, "themeId", ""), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * optional; only authorized derivatives returned
   *
   * @generated from field: string customer_org_id = 3;
   */ _define_property(this, "customerOrgId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCustomerContextsRequest, "runtime", proto3);
_define_property(ListCustomerContextsRequest, "typeName", "mono.projectdata.v1.ListCustomerContextsRequest");
_define_property(ListCustomerContextsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 4,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "theme_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "customer_org_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCustomerContextsResponse
 */ export class ListCustomerContextsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCustomerContextsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCustomerContextsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCustomerContextsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCustomerContextsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.CustomerContextSummary summaries = 1;
   */ _define_property(this, "summaries", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCustomerContextsResponse, "runtime", proto3);
_define_property(ListCustomerContextsResponse, "typeName", "mono.projectdata.v1.ListCustomerContextsResponse");
_define_property(ListCustomerContextsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "summaries",
            kind: "message",
            T: CustomerContextSummary,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PreviewCustomerContextRequest
 */ export class PreviewCustomerContextRequest extends Message {
    static fromBinary(bytes, options) {
        return new PreviewCustomerContextRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PreviewCustomerContextRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PreviewCustomerContextRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PreviewCustomerContextRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * interaction | theme (accepted only)
   *
   * @generated from field: string source_kind = 4;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string source_id = 5;
   */ _define_property(this, "sourceId", ""), /**
   * @generated from field: string title = 6;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string summary = 7;
   */ _define_property(this, "summary", ""), /**
   * @generated from field: repeated mono.projectdata.v1.LibraryAudienceGrant audiences = 8;
   */ _define_property(this, "audiences", []), /**
   * binds exact content, audience and source revision
   *
   * @generated from field: string preview_token = 9;
   */ _define_property(this, "previewToken", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PreviewCustomerContextRequest, "runtime", proto3);
_define_property(PreviewCustomerContextRequest, "typeName", "mono.projectdata.v1.PreviewCustomerContextRequest");
_define_property(PreviewCustomerContextRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "audiences",
            kind: "message",
            T: LibraryAudienceGrant,
            repeated: true
        },
        {
            no: 9,
            name: "preview_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ReleaseCustomerContextResponse
 */ export class ReleaseCustomerContextResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReleaseCustomerContextResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReleaseCustomerContextResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReleaseCustomerContextResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReleaseCustomerContextResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CustomerContextSummary summary = 1;
   */ _define_property(this, "summary", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReleaseCustomerContextResponse, "runtime", proto3);
_define_property(ReleaseCustomerContextResponse, "typeName", "mono.projectdata.v1.ReleaseCustomerContextResponse");
_define_property(ReleaseCustomerContextResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "summary",
            kind: "message",
            T: CustomerContextSummary
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetCustomerContextResponse
 */ export class GetCustomerContextResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCustomerContextResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCustomerContextResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCustomerContextResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCustomerContextResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CustomerContextSummary summary = 1;
   */ _define_property(this, "summary", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCustomerContextResponse, "runtime", proto3);
_define_property(GetCustomerContextResponse, "typeName", "mono.projectdata.v1.GetCustomerContextResponse");
_define_property(GetCustomerContextResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "summary",
            kind: "message",
            T: CustomerContextSummary
        }
    ]));
